import { useQuery } from "react-query";
import ENDPOINTS from "../../services/endPoints";
import { QueryReturnType } from "../../services/networking.service";

interface IProps {
  page: string;
  limit: string;
  search: string;
}

export const useGetBoxList = ({
  page,
  limit,
  search,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_BOX_LIST, { page: page, limit: limit, search: search }],
    {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      staleTime: 0, // Always fetch fresh data
      cacheTime: 0, // Don't cache the response
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
